/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-23 11:11:21
 * @LastEditors: limin
 * @LastEditTime: 2021-04-14 18:51:05
 */
import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import products from './modules/products'
import address from './modules/address'
import common from './modules/common'
import init from './modules/init'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)
export default new Vuex.Store({
  // 设计数据中心 模块
  modules: {  // 分模块
    init,
    address,
    common,
    cart, 	  // 购物车 cart
    products // 商品 products
  },
  plugins: [createPersistedState({
    //指定存储模式
    storage: window.sessionStorage,
    //指定要存储的模块
    reducer(m){
      const { address,common,cart } = m
      return {
        common,
        address,
        cart
      }
    }
  })]
})
